const operatorChars = {
  less_than: "&lt;",
  equal: "=",
  not_equal: "exclude",
  greater_than: "&gt;",
  starts_with: "starts with",
  contains: "contains",
}

export default function Operator({ operator, disableEquals = false }) {
  const char = operatorChars[operator]

  if (!char || (disableEquals && operator === "equal")) {
    return null
  }

  return <span dangerouslySetInnerHTML={{ __html: char }} />
}
